import React, { Component } from "react";
import { ResponsiveTable, CircularProgress } from "..";
import { FormattedDate, FormattedTime } from "react-intl";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";
import { OrderItemUI, Pagination } from "..";
import { QuoteStatus } from "../../utils/Quote/Quote";
import { getProductTypeName } from "../../utils/Order/Order";
import { localDateTime } from "../../utils/Helper";

class QuoteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
    };
  }

  handleOnChangePage = (nextPage) => {
    this.setState({
      page: nextPage,
    });

    this.props.requestQuotes({
      pageFilter: {
        startIndex: (nextPage - 1) * 10,
        length: 10,
        ...this.state.filter,
      },
    });
  };

  render() {
    const progressStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: "30px",
      right: 0,
      margin: "auto",
    };

    return (
      <div className="content" style={this.props.loading ? { position: "relative" } : {}}>
        {this.props.loading && <CircularProgress style={progressStyle} />}
        <ResponsiveTable
          style={this.props.loading ? { opacity: "0.3" } : { margin: 0 }}
          emptyText={"No quotes"}
        >
          <thead>
            <tr>
              <th>Req. at</th>
              <th>Req. by</th>
              <th>Resp. at</th>
              <th>Resp. by</th>
              <th>Trading desk</th>
              <th>Product</th>
              <th>Side</th>
              <th>Ticker</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Status</th>
              <th>Used</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {this.props.quotes.map((quote) => (
              <tr key={`quote-${quote.AdvisorQuoteId}`}>
                <td>
                  <Datetime value={localDateTime(quote.AdvisorQuoteRequestedDate)} />
                </td>
                <td>
                  <strong>{quote.AdvisorQuoteRequestedBy}</strong>
                </td>

                <td>
                  {quote.AdvisorQuoteStatus != QuoteStatus.WAITING ? (
                    <Datetime value={localDateTime(quote.AdvisorQuoteRespondedDate)} />
                  ) : (
                    ""
                  )}
                </td>

                <td>
                  {quote.AdvisorQuoteStatus != QuoteStatus.WAITING ? (
                    <strong>{quote.AdvisorQuoteRespondedBy}</strong>
                  ) : (
                    ""
                  )}
                </td>

                <td>{quote.tradingDeskName}</td>
                <td>{getProductTypeName(quote.AssetClassForm)}</td>
                <td sm={{ i: 1, j: 0 }}>
                  {OrderItemUI.renderOrderSide({
                    OrderSide: quote.AdvisorQuoteIsBuy ? "Buy" : "Sell",
                  })}
                </td>
                <td sm={{ i: 1, j: 1 }}>
                  <strong>{quote.AssetTicker}</strong>
                </td>
                <td sm={{ i: 1, j: 2 }} className="text-right">
                  <FormattedNumber
                    value={quote.AdvisorQuoteQuantity}
                    style={{ fontWeight: "bold" }}
                    dataTypeDecimalName="quantity"
                  />
                </td>

                <td sm={{ i: 1, j: 3 }} className="text-right">
                  {quote.AdvisorQuoteStatus == QuoteStatus.PRICED ||
                  quote.AdvisorQuoteStatus == QuoteStatus.USED ||
                  quote.AdvisorQuoteStatus == QuoteStatus.REJECTED_BY_SENDER ? (
                    <strong>
                      <FormattedNumber
                        value={quote.AdvisorQuotePrice}
                        decimalScale={quote.SubAssetClassDecimalPlaces}
                        dataTypeDecimalName="price"
                      />
                    </strong>
                  ) : (
                    ""
                  )}
                </td>
                <td>
                  <Status status={quote.AdvisorQuoteStatus} />
                </td>
                <td>{quote.wasUsed ? "Yes" : "No"}</td>
                <td>{quote.AdvisorQuoteRejectReason}</td>
              </tr>
            ))}
          </tbody>
        </ResponsiveTable>
        <Pagination page={this.state.page} pages={this.props.pages} onChangePage={this.handleOnChangePage} />
      </div>
    );
  }
}

const Datetime = (props) => {
  if (props.value == undefined) return <span>-</span>;

  const value = Date.parse(props.value);

  return (
    <span>
      <FormattedDate value={value} /> <FormattedTime value={value} hour12={false} />
    </span>
  );
};

const Status = (props) => {
  switch (props.status) {
    case QuoteStatus.WAITING:
      return <span>Waiting</span>;
    case QuoteStatus.PRICED:
      return <span>Priced</span>;
    case QuoteStatus.USED:
      return <span>Used</span>;
    case QuoteStatus.REJECTED_BY_SENDER:
      return <span>Rejected</span>;
    case QuoteStatus.REJECTED_BY_RECEIVER:
      return <span>Rejected</span>;
  }
};

export default QuoteList;
